import React, { Component } from 'react';
//import { Alert } from 'reactstrap' ;
//import logo from './logo.svg';
import './App.css';
import './css/getConfiguracion.css';
import './css/getVendedor.css';
import './css/getCuentas.css';
import './css/getMenu.css';
import './css/getRubros.css';
import './css/getSubrubros.css';
import './css/getItems.css';
import './css/getNota.css';
import './css/getTeclado.css';
import './css/getTotales.css';
import './css/getPreferencias.css';
import './css/getCombo.css';
import './css/getCerrar.css';
import './css/getComponents.scss';
//import GetCuentas from './Componentes/getCuentas';
import GetRubros from './Componentes/getRubros';
import GetSubrubros from './Componentes/getSubrubros';
import GetItems from './Componentes/getItems';
import GetItemsv2 from './Componentes/getItemv2';
import GetTeclado from './Componentes/getTeclado';
import GetMenu from './Componentes/getMenu';
import GetNota from './Componentes/getNota';
import GetCuentas from './Componentes/getCuentas';
import GetVendedor from './Componentes/getVendedor';
import GetConfiguracion from './Componentes/getConfiguracion';
import GetTotales from './Componentes/getTotales';
import GetTimerCajaActiva from './Componentes/getTimerCajaActiva';
import GetMsgboxCaja from './Componentes/getMsgboxCaja';
import GetPreferencia from './Componentes/getPreferencia';
import GetCombo from './Componentes/getCombo';
import GetCerrar from './Componentes/getCerrar';
import GetPax from './Componentes/getPax';


class App extends Component {

  state = {
    id_rubro : '0' ,
    ok_rubro : false ,
    id_subrubro : '0' ,
    ok_subrubro : false ,
    ok_item : false ,
    rubros : [] ,
    subrubros : [] ,
    items : [] ,
    url_global : "http://localhost/neola/index.php/" ,
    url_proxyurl : ""/*https://cors-anywhere.herokuapp.com/*/,
    nombre_maquina : "",
    nombre_maquina_impresoras : "",
    sw_grabado : "",
    cantidad : '',
    array_nota : [],
    array_nota_combo : [],
    lbl_total : '0.00' ,
    id_vendedor : 0 ,
    nombre_vendedor : '',
    _visible_alert : true,
    ac_nota : 0 ,
    id_cuenta : 0 ,
    cuenta : '' ,
    cuenta_apertura :0 ,
    id_cabecera : 0 ,
    cajas : [],
    id_caja : 0,
    id_caja_diaria :0 ,
    loading : false ,
    id_item_preferencia : 0 ,
    lbl_item_preferencia : '' ,
    secuencial_actual : 0,
    id_item_combo : 0 ,
    cantidad_max : 0,
    cerrando:false,
    cambiar_pax:false,
    codigo_cliente:'',
    nombre_cliente:'',
    correo_cliente:'',
    telefono_cliente:'',
    direccion_cliente:'',
    id_codigo_cliente:0,
    descuento_final:0,
    propina_final:0,
    id_forma_pago:0,
    sw_tipo_pantalla:0,
    id_tipo_pantalla:0,
    id_sub_puntoventa_pantalla:0,
    pax:0
  }
  consultarRubroAPI = () => {
    const sw_tipo_pantalla = Number(this.state.sw_tipo_pantalla)
    const id_tipo_pantalla = Number(this.state.id_tipo_pantalla)
    if(sw_tipo_pantalla===0){
      const url= this.state.url_proxyurl + this.state.url_global + "webservices/getrubros";
        fetch( url ,{
          method: 'GET',
          headers: {
            /*Accept:'application/json',
            'Content-Type' : 'application/json'*/
          }
        } )
        .then(res => res.json())
        .then((data) => {
          this.setState({ rubros: data, ok_rubro : true })
        })
        .catch(console.log)
    }else{
      //const id_subrubro = this.state.id_subrubro;
      const id_cuenta = this.state.id_cuenta;
      //console.log(id_subrubro);
      const url= this.state.url_proxyurl + this.state.url_global + "webservices/getItemsv2/"+id_cuenta+"/"+id_tipo_pantalla+"/0";
      //console.log(url);
        fetch(url)
        .then(res => res.json())
        .then((data) => {
          this.setState({ items: data[0].data , ok_item : true,id_sub_puntoventa_pantalla: data[0].id_tipo_pantalla})
        })
        .catch(console.log)
    }
  }
  consultarSubRubroAPI = () => {
    //console.log("consultarSubRubroAPI");
    const id_rubro = this.state.id_rubro;
    //console.log(id_rubro+ " "+ this.state.id_subrubro);
    const url= this.state.url_proxyurl + this.state.url_global + "webservices/getSubRubros/"+id_rubro;
      fetch(url)
      .then(res => res.json())
      .then((data) => {
        this.setState({ subrubros: data, ok_subrubro : true })
      })
      .catch(console.log)
  }


  consultarItemAPI = () => {
    //console.log("consultarItemAPI");
    const id_subrubro = this.state.id_subrubro;
    const id_cuenta = this.state.id_cuenta;
    //console.log(id_subrubro);
    const url= this.state.url_proxyurl + this.state.url_global + "webservices/getItems/"+id_subrubro+"/"+id_cuenta;
    //console.log(url);
      fetch(url)
      .then(res => res.json())
      .then((data) => {
        this.setState({ items: data , ok_item : true})
      })
      .catch(console.log)
  }
  consultarDetalleFacturacionAPI = (id_cabecera) => {
    //console.log("consultarItemAPI");
    //console.log(id_subrubro);
    const url= this.state.url_proxyurl + this.state.url_global + "webservices/getDetalleFacturacion/"+id_cabecera;
    //console.log(url);

      fetch(url)
      .then(res => res.json())
      .then((data) => {

          /************************************DET COMBO *****************/
          //console.log("ssssss");
          let array_nota_combo = [];
          if(data[2].length>0){
            let secuencial = 0;
            let array_nota_combo_sel = [];
            //let ac_array_nota_combo_sel = 0;
            let ac_nota = 0;
            data[2].forEach(cpDTC => {
              if(secuencial!==cpDTC.id_detalle){
                //ac_array_nota_combo_sel = 0;
                if(secuencial>0){
                  array_nota_combo= [ ...array_nota_combo, {
                    'secuencial': ac_nota,
                    'detalle': array_nota_combo_sel
                  }]
                  array_nota_combo_sel = [];
                }
                data[1].forEach(cp_CAB => {
                    if(cpDTC.id_detalle===cp_CAB.id_detalle){
                      ac_nota = cp_CAB.secuencial;
                      cp_CAB.id_combo = '1';
                    }
                });
                secuencial =cpDTC.id_detalle;
              }
              //ac_array_nota_combo_sel++;
              array_nota_combo_sel= [ ...array_nota_combo_sel,cpDTC]

            });

            if(secuencial>0){
              array_nota_combo= [ ...array_nota_combo, {
                'secuencial': ac_nota,
                'detalle': array_nota_combo_sel
              }]
            }
            //console.log(array_nota_combo)
          }

          //console.log(data[0].total)
          /************************************DET COMBO *****************/


          this.setState({ array_nota: data[1], ac_nota: data[0].total,array_nota_combo },  () =>
          {
           this.getTotalComprobante();
          })
      })
      .catch(console.log)
  }
  cancelar_preferencia = () =>{
    this.setState({
      id_item_preferencia : -1
    })
  }


  getlabelPreferenciaItem = (secuencial_actual) =>{
    const array_nota = this.state.array_nota;
    if(Number(secuencial_actual)>0){
        if(array_nota.length === 0) return "";
        let lbl_item_preferencia ="";
        array_nota.forEach(cp => {
        if(Number(cp.secuencial)===Number(secuencial_actual)){
            lbl_item_preferencia= lbl_item_preferencia + cp.preferencia;
          }
        })
        if(lbl_item_preferencia){
            return " -- "+lbl_item_preferencia;
        }

    }
    return "";
  }

  getPreferenciaItem = () =>{
    const secuencial_actual = this.state.secuencial_actual;
    const array_nota = this.state.array_nota;
    if(secuencial_actual>0){
        if(array_nota.length === 0) return null;
        let id_item_preferencia = 0;
        let lbl_item_preferencia ="";
        array_nota.forEach(cp => {
          if(cp.opcion==='' && cp.secuencial===secuencial_actual){
            id_item_preferencia =cp.id_item;
            lbl_item_preferencia= cp.detalle;
          }
        })
        this.setState({
          id_item_preferencia ,lbl_item_preferencia
        })
    }
  }
  ir_preferencia = (preferencia) =>{
    const secuencial_actual = this.state.secuencial_actual;
    const array_nota = this.state.array_nota;
    array_nota.forEach(cp => {
      if(cp.opcion==='' && cp.secuencial===secuencial_actual){
        cp.preferencia = preferencia;
      }
    })
    this.setState({
      id_item_preferencia : -1
    })
  }
  getEncerarAPI = (nombre_maquina) => {
    const url= this.state.url_proxyurl + this.state.url_global + "webservices/getEncerar/"+nombre_maquina;
    //console.log(url);
    fetch(url)
      .catch(console.log)
  }
  getCerrarCabecera =()=>{
    const array_nota = this.state.array_nota;
    if(array_nota.length === 0) return null;
    let ac_ingreso = 0;
    let ac_total =0;
    array_nota.forEach(cp => {
      if(cp.opcion==='*'){
        ac_ingreso++;
      }
      ac_total++
    })
    if(ac_ingreso===0) return null;
    if(ac_ingreso!==ac_total) return null;
    this.setState({
      cerrando:true
    })

  }
  getActualizarCabeceraPax =()=>{
    this.setState({
      cambiar_pax:true
    })
  }


  getActualizarCabecera = () => {
    const array_nota = this.state.array_nota;
    if(array_nota.length === 0) return null;
    let ac_ingreso = 0;
    array_nota.forEach(cp => {
      if(cp.opcion===''){
        ac_ingreso++;
      }
    })
    if(ac_ingreso===0) return null;
    const url= this.state.url_proxyurl + this.state.url_global + "webservices/getActualizarCabecera";
    //var data = {username: 'example'};
    var obj = { accion:'grabar', array_nota: this.state.array_nota, id_cuenta: this.state.id_cuenta, id_cabecera: this.state.id_cabecera,
                nombre_maquina: this.state.nombre_maquina_impresoras, id_vendedor: this.state.id_vendedor,
                nombre_maquina_tablet : this.state.nombre_maquina, cuenta: this.state.cuenta,id_caja:this.state.id_caja,
                id_caja_diaria: this.state.id_caja_diaria, array_nota_combo:this.state.array_nota_combo,pax:this.state.pax};

    fetch(url, {
      method: 'POST', // or 'PUT'
      body: JSON.stringify(obj), // data can be `string` or {object}!
      headers:{
        'Accept':'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then(res => res.json())
    .then((data) => {
      //console.log(data[0].status)
      if(data[0].status==="ok"){
        this.Abtn_encerar_cuenta();
      }
    })
    .catch(console.log)
    this.setState({
      loading:true
    })
    /*.catch(error => console.error('Error:', error))
    .then(response => console.log('Success:', response))
*/
  }
  validar_data = (id_caja_diaria_T,id_caja_T) =>{
    const id_caja_diaria = this.state.id_caja_diaria;
    const id_caja = this.state.id_caja;
    if(id_caja_diaria_T!==id_caja_diaria||id_caja_T!==id_caja){
      this.setState(
        {
          id_caja : id_caja_T, id_caja_diaria :id_caja_diaria_T
        }
      )
    }
  }
  //this.setState({ id_caja_diaria: data[0].id_caja_diaria,id_caja: data[0].id_caja })
  validar_caja_activa = () => {
    const sw_grabado  = this.state.sw_grabado;
    if(sw_grabado!==''){
      if(this.state.nombre_maquina){
        const url= this.state.url_proxyurl +this.state.url_global + "webservices/getCajaActiva/"+this.state.nombre_maquina;
          fetch( url)
          .then(res => res.json())
          .then((data) => {
            this.validar_data(data[0].id_caja_diaria,data[0].id_caja);
          })
          .catch(console.log)
      }
    }
  }
  getCajaAPI = () => {
    const url= this.state.url_proxyurl +this.state.url_global + "webservices/getCajas/";
      fetch( url)
      .then(res => res.json())
      .then((data) => {
        this.setState({ cajas: data })
      })
      .catch(console.log)
  }

  getPrecuentaAPI = () => {
    const id_cabecera = this.state.id_cabecera;
    const nombre_maquina_impresoras = this.state.nombre_maquina_impresoras;
    if(id_cabecera===0){
      return null;
    }
    const url= this.state.url_proxyurl + this.state.url_global + "webservices/getImprimirPrecuenta/"+id_cabecera+"/"+nombre_maquina_impresoras;
    //console.log(url);
    fetch(url)
    .catch(console.log);
    this.Abtn_encerar_cuenta();
  }
  getVendedorAPI = (id_vendedor) => {
    const url= this.state.url_proxyurl + this.state.url_global + "webservices/getVendedor/"+id_vendedor;
    //console.log(url);
    fetch(url)
    .then(res => res.json())
    .then((data) => {
      this.setState({ id_vendedor : Number(data[0].id_personal),nombre_vendedor : data[0].nombre })
    })
    .catch(console.log)
  }
  getCuentaAPI = (id_cuenta,cuenta) => {
    const url= this.state.url_proxyurl + this.state.url_global + "webservices/getOpenCuenta/"+id_cuenta+"/"+this.state.nombre_maquina;
    //console.log(url);
    fetch(url)
    .then(res => res.json())
    .then((data) => {
      if(data[0].msgbox!==''){
        alert(data[0].msgbox)
      }
      this.setState({ id_cuenta : Number(data[0].id_cuenta),cuenta_apertura : data[0].apertura,id_cabecera : data[0].id_cabecera, cuenta ,loading:false })
      this.getCabeceraInfoAPI(data[0].id_cabecera)
    })
    .catch(console.log)

    this.setState({
      loading:true
    })
  }

  getCabeceraInfoAPI = (id_cabecera) => {
    const url= this.state.url_proxyurl + this.state.url_global + "webservices/getOpenCabecera/"+id_cabecera;
    //console.log(url);
    fetch(url)
    .then(res => res.json())
    .then((data) => {
      let paxt = Number(data[0].numero_pax)
      if(paxt===0)paxt=1
      this.setState({ pax :paxt })
      //if(data[0].msgbox!==''){
        //alert(data[0].msgbox)
      //}
      //this.setState({ id_cuenta : Number(data[0].id_cuenta),cuenta_apertura : data[0].apertura,id_cabecera : data[0].id_cabecera, cuenta ,loading:false })
    })
    .catch(console.log)

    /*this.setState({
      loading:true
    })*/
  }


  getTotalComprobante = () =>{
    console.log("calcular");
    const array_nota = this.state.array_nota;
    const array_nota_combo = this.state.array_nota_combo;



    let total_precio_final = 0;
    if(array_nota.length === 0) return null;
    array_nota.forEach(cp => {
      total_precio_final=total_precio_final+Number(cp.precio_total);
    })
    array_nota_combo.forEach(cp => {
      //total_precio_final=total_precio_final+Number(cp.detalle);
      cp.detalle.forEach(cp_dt => {
        total_precio_final=total_precio_final+Number(cp_dt.precio_total);
      })
    })

    this.setState({ lbl_total: total_precio_final, secuencial_actual :this.state.ac_nota})
    //console.log(total_precio_final);
  }
  datosBusquedaRubro = () => {
    this.consultarRubroAPI();
  }
  datosBusquedaSubRubro = (id_rubro) => {
    if(id_rubro==='') return null;
    this.setState(
      {
        id_rubro, id_subrubro:'0', ok_subrubro : false, subrubros : []
      } , () => {
        this.consultarSubRubroAPI();
      }
    )

  }
  Abtn_encerar_cuenta = () => {
    this.setState(
      {
        id_cuenta : 0,
        id_rubro : '0' ,
        ok_rubro : false ,
        id_subrubro : '0' ,
        ok_subrubro : false ,
        ok_item : false ,
        rubros : [] ,
        subrubros : [] ,
        items : [] ,
        cantidad : '',
        array_nota : [],
        array_nota_combo : [] ,
        lbl_total : '0.00' ,
        ac_nota : 0 ,
        cuenta : '' ,
        cuenta_apertura : 0,
        loading :false ,
        secuencial_actual: 0 ,
        id_item_preferencia : 0,
        id_item_combo : 0,
        cantidad_max : 0,
        cerrando:false,
        cambiar_pax:false,
        pax:1
      }
    )

  }
  Abtn_abrir_cuenta = (id_cuenta , cuenta) => {
    /*this.setState(
      {
        id_cuenta ,
        cuenta
      } ,  () =>
      {

      }
    )*/
    this.getCuentaAPI(id_cuenta,cuenta);
    this.consultarRubroAPI();
  }

  onRemoveItem = (secuencial,opcion) => {
    if(opcion==="*"){
      return null;
    }
    /*
    this.setState(state => {
      const list = this.state.array_nota.filter(item => item.secuencial !== secuencial);
      return {
        array_nota: list,
      };
    },state => {
      const list = this.state.array_nota_combo.filter(item => item.secuencial !== secuencial);
      return {
        array_nota: list,
      };
    },  () =>
    {
     this.getTotalComprobante();
   });*/
   //console.log(this.state.array_nota_combo);

   const list_array_nota = this.state.array_nota.filter(item => item.secuencial !== secuencial);
   const list_array_nota_combo = this.state.array_nota_combo.filter(item => item.secuencial !== secuencial);
   //console.log(list_array_nota_combo);
    this.setState({
      array_nota : list_array_nota,
      array_nota_combo :list_array_nota_combo
    }
    ,  () =>
    {
     this.getTotalComprobante();
    });
  };

  onSecuencial = (secuencial_actual) => {
      this.setState({
        secuencial_actual
      });
  }
  datosBusquedaItem = (id_subrubro) => {
    this.setState(
      {
        id_subrubro , ok_item : false
      } , () => {
        this.consultarItemAPI();
      }
    )

  }
  addnewCombo = (array_nota_combo_sel) =>{
    let ac_nota = this.state.ac_nota;
    //console.log(ac_nota)
    this.setState({
     array_nota_combo: [ ...this.state.array_nota_combo, {
       'secuencial': ac_nota,
       'detalle': array_nota_combo_sel
     }],id_item_combo:-1,cantidad_max : 0},  () =>
     {
      this.getTotalComprobante();
     });

  }
  exitCombo =()=>{
    let ac_nota = this.state.ac_nota;
    this.setState({
      id_item_combo:-1,cantidad_max : 0},  () =>
     {
      this.onRemoveItem(ac_nota,"");
     });
  }
 retroceder =()=>{
    const id_sub_puntoventa_pantalla = this.state.id_sub_puntoventa_pantalla

    this.setState(
      {
         ok_item : false
      } , () => {
          this.consultarItemAPIV2(id_sub_puntoventa_pantalla,1);
      }
    )
 }
 consultarItemAPIV2 =(id_sub_puntoventa_pantalla,accion)=>{
   const id_cuenta = this.state.id_cuenta;
   //console.log(id_subrubro);
   const url= this.state.url_proxyurl + this.state.url_global + "webservices/getItemsv2/"+id_cuenta+"/"+id_sub_puntoventa_pantalla+"/"+accion;
   //console.log(url);
     fetch(url)
     .then(res => res.json())
     .then((data) => {
       this.setState({ items:  data[0].data , ok_item : true, id_sub_puntoventa_pantalla:data[0].id_tipo_pantalla})
     })
     .catch(console.log)
 }

  recuperar_itemV2 = (id_sub_puntoventa_pantalla,activo,id_item, item, precio_venta, iva, servicio, sw_incluido, id_rubro, id_subrubro, pfinal,id_combo,carga_maxima) => {
    if(Number(activo)===1){
      if(Number(id_item)>0){
        this.recuperar_item(id_item, item, precio_venta, iva, servicio, sw_incluido, id_rubro, id_subrubro, pfinal,id_combo,carga_maxima)
      }
      if(Number(id_sub_puntoventa_pantalla)>0){

        this.setState(
          {
             ok_item : false
          } , () => {
            this.consultarItemAPIV2(id_sub_puntoventa_pantalla,0);
          }
        )

      }
    }
  }
  recuperar_item = (id_item, item, precio_venta, iva, servicio, sw_incluido, id_rubro, id_subrubro, pfinal,id_combo,carga_maxima) => {
    //console.log(pfinal);

         //id_vendedor
         //cantidad
         let cantidad = this.state.cantidad;
         if(isNaN(cantidad)){
           cantidad=1;
         }else{
           if(Number(cantidad)<=0){
             cantidad=1;
           }
         }
         let nombre_item =item;
         let costo_unitario=pfinal;
         const roundTo = require('round-to');
         let costo =  roundTo(Number(pfinal)* Number(cantidad),2);
         let impuesto_IVA=iva;
         let impuesto_Servicio=servicio;
         let ac_nota = this.state.ac_nota;
         let id_item_combo = 0;
         if(id_combo==='1'){
           id_item_combo = id_item;
         }
         ac_nota++;
         this.setState({
          array_nota: [ ...this.state.array_nota, {
          	'secuencial': ac_nota,
          	'opcion': '',
            'cantidad' : cantidad,
            'detalle' : nombre_item,
            'precio_total' : costo ,
            'precio_unitario' : costo_unitario ,
            'impuesto_IVA' : impuesto_IVA ,
            'impuesto_Servicio' : impuesto_Servicio ,
            'id_detalle' : 0 ,
            'cant_eliminada' : 0 ,
            'id_item' : id_item ,
            'id_rubro' : id_rubro ,
            'id_subrubro' : id_subrubro,
            'precio_venta' : precio_venta ,
            'preferencia' :'',
            'id_combo' : id_combo,
            'carga_maxima': carga_maxima
          }],id_item_combo ,cantidad_max : carga_maxima, ac_nota , cantidad:''},  () =>
          {
           this.getTotalComprobante();
          });


//id_item, item, id_detalle, cantidad, cant_eliminada, precio_venta, iva, servicio, id_rubro, id_subrubro, timer_1, pfinal
  }

  toogle(){
    this.setState(
      {
        _visible_alert : false
      }
    )
  }
  setTeclado = (cantidad) => {
    if(cantidad ==="DEL"){
      cantidad="";
    }else{
      cantidad=this.state.cantidad+""+cantidad;
    }
    this.setState(
      {
        cantidad
      }
    )
  }

  setVendedor = (id_vendedor) => {

    const id_vendedor_busq = id_vendedor.trim();
    if(id_vendedor_busq===''){
      alert('Ingrese Vendedor');
        return null;
    }
    this.getVendedorAPI(id_vendedor);
    /*this.setState(
      {
        id_vendedor
      } ,  () =>
      {
       this.consultarRubroAPI();
      }
    )*/
  }

  setMaquina = (nombre_maquina) => {
    this.setState(
      {
        nombre_maquina
      }
    )
  }
  setMaquinaImpresora = (nombre_maquina_impresoras) => {
    this.setState(
      {
        nombre_maquina_impresoras
      }
    )
  }
  setIdCaja = (id_caja) => {
    this.setState(
      {
        id_caja
      }
    )
  }


  setURL = (url_global) => {
    this.setState(
      {
        url_global
      }, () => {
        this.getCajaAPI();
      }
    )
  }
  setConfiguracion = () => {
    localStorage.nombre_maquina = this.state.nombre_maquina;
    localStorage.nombre_maquina_impresoras = this.state.nombre_maquina_impresoras;
    localStorage.url_global = this.state.url_global;
    localStorage.sw_grabado = 'SI';
    this.getConfiguracionAPI();
    this.setState(
      {
        sw_grabado : 'SI'
      }
    )
  }
  getConfiguracionAPI = () => {
    const url= this.state.url_proxyurl + this.state.url_global + "webservices/getConfiguracion/"+this.state.nombre_maquina+"/"+this.state.id_caja;
    console.log(url);
    fetch(url)
      .catch(console.log)
  }

inputChangedHandler = (event) => {
    //const updatedKeyword = event.target.value;
    // May be call for search result
}
getRegresarActualizarPax=(pax)=>{
  let paxFinal = Number(pax)
  if(paxFinal<=0)paxFinal=1
  this.setState({
    pax:paxFinal,
    cambiar_pax:false
  })
  const id_cabecera = Number(this.state.id_cabecera)
  if(id_cabecera>0){
        const url= this.state.url_proxyurl + this.state.url_global + "webservices/getActualizarCabeceraInfo/"+id_cabecera+"/"+ Number(paxFinal);
        var obj = { accion:'grabar'};
        fetch(url, {
          method: 'POST', // or 'PUT'
          body: JSON.stringify(obj), // data can be `string` or {object}!
          headers:{
            'Accept':'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(res => res.json())
        .then((data) => {

        })
        .catch(console.log)

  }


}
  getRegresar =()=>{
    this.setState({
      cerrando:false,
      cambiar_pax:false
    })
  }

  render() {



     //localStorage.nombre_maquina="";

    const id_cuenta  = this.state.id_cuenta;
    const id_vendedor  = this.state.id_vendedor;
    const sw_grabado  = this.state.sw_grabado;
    const id_caja_diaria  = Number(this.state.id_caja_diaria);
    const id_item_preferencia  = Number(this.state.id_item_preferencia);
    const id_item_combo  = Number(this.state.id_item_combo);
    const cerrando = this.state.cerrando
    const cambiar_pax = this.state.cambiar_pax
    //const nombre_maquina = this.state.nombre_maquina;
    let modulo;
        /*if(sw_grabado===''){
          if(!localStorage.nombre_maquina){
            return null;
          }
        }*/
    //console.log("sss "+this.state.sw_tipo_pantalla)

      if(sw_grabado===''){
        modulo =<div className="grid-container-configuracion">
                  <GetConfiguracion setIdCaja={this.setIdCaja} cajas={this.state.cajas} id_caja={this.state.id_caja} getCajaAPI={this.getCajaAPI} setMaquinaImpresora={this.setMaquinaImpresora} setConfiguracion={this.setConfiguracion} setURL={this.setURL} setMaquina={this.setMaquina} nombre_maquina={this.state.nombre_maquina} url_global={this.state.url_global} nombre_maquina_impresoras={this.state.nombre_maquina_impresoras}  />
                </div>
      }else{
        if(id_caja_diaria===0){
          modulo =<React.Fragment>
                      <div className="grid-container-vendedor">
                        <GetMsgboxCaja validar_caja_activa={this.validar_caja_activa} />
                      </div>
                  </React.Fragment>
        }else{
          if(id_vendedor===0){
          //  console.log("xxx"+id_vendedor);
            modulo =
            <div className="grid-container-vendedor">
              <GetVendedor setVendedor={this.setVendedor} Abtn_encerar_cuenta={this.Abtn_encerar_cuenta} setTeclado={this.setTeclado}  cuenta={this.state.cuenta} />
            </div>
          }else{
            if (id_cuenta!==0) {
              if(id_item_combo>0){
                modulo =<React.Fragment>
                          <GetCombo exitCombo={this.exitCombo} addnewCombo={this.addnewCombo} cantidad_max={this.state.cantidad_max} id_item_combo={this.state.id_item_combo} url_proxyurl={this.state.url_proxyurl} url_global={this.state.url_global} consultarCombo={this.consultarCombo}/>
                        </React.Fragment>
              }else{
                if(id_item_preferencia>0){
                    modulo =<React.Fragment>
                              <GetPreferencia cancelar_preferencia={this.cancelar_preferencia} ir_preferencia={this.ir_preferencia} lbl_item_preferencia={this.state.lbl_item_preferencia} url_proxyurl={this.state.url_proxyurl} url_global={this.state.url_global} id_item_preferencia={this.state.id_item_preferencia} />
                            </React.Fragment>
                }else{
                  let sub_modulo

                  if(cerrando===true){
                    sub_modulo=<div id="loader" className="loader_msg_notificacion is-active" data-text=""><GetCerrar precio_total={this.state.lbl_total} url_proxyurl={this.state.url_proxyurl} url_global={this.state.url_global} getRegresar={this.getRegresar} /></div>
                  }
                  if(cambiar_pax===true){
                    sub_modulo=<div id="loader" className="loader_msg_notificacion is-active" data-text=""><GetPax pax={this.state.pax} getRegresar={this.getRegresar} getRegresarActualizarPax={this.getRegresarActualizarPax} /></div>
                  }



                  modulo = <div className="form_global">
                  <div className={(Number(this.state.sw_tipo_pantalla)===0)?"grid-container":"grid-container-v2"}>
                   <div className="form_menu">
                     <GetMenu getActualizarCabeceraPax={this.getActualizarCabeceraPax} getCerrarCabecera={this.getCerrarCabecera}  getActualizarCabecera={this.getActualizarCabecera} getPreferenciaItem={this.getPreferenciaItem} getPrecuentaAPI={this.getPrecuentaAPI} Abtn_encerar_cuenta={this.Abtn_encerar_cuenta} />
                   </div>
                   <div className="form_teclado">
                     <div className="form_datos">
                      <GetTotales nombre_vendedor={this.state.nombre_vendedor} lbl_total={this.state.lbl_total} cuenta={this.state.cuenta} />
                     </div>
                     <div className="form_teclado_all">
                       <GetTeclado  getActualizarCabecera={this.getActualizarCabecera} cantidad={this.state.cantidad} inputChangedHandler={this.inputChangedHandler} setTeclado={this.setTeclado} cuenta={this.state.cuenta} />
                     </div>
                   </div>
                   {(Number(this.state.sw_tipo_pantalla)===0)?
                     <React.Fragment>
                       <div className="form_rubros">
                         <div className="form_rubros_all"><GetRubros consultarRubroAPI={this.consultarRubroAPI} datosBusquedaSubRubro={this.datosBusquedaSubRubro} rubros={this.state.rubros} id_rubro={this.state.id_rubro} ok_rubro={this.state.ok_rubro} /></div>
                         <div className="form_subrubros_all"><GetSubrubros datosBusquedaItem={this.datosBusquedaItem} subrubros={this.state.subrubros} id_subrubro={this.state.id_subrubro} ok_subrubro={this.state.ok_subrubro} /></div>
                       </div>
                       <div className="form_items">
                         <GetItems recuperar_item={this.recuperar_item} items={this.state.items} ok_item={this.state.ok_item} />
                       </div>
                     </React.Fragment>
                   :
                   <div className="form_items">
                    <div className="cssversion_pw100 cssversion_ph100 cssversion_colorblanco" >
                      <button className="boton_item_span" style={{"width":"80px","height":"50px"}} onClick={ () => this.retroceder()}>Retroceder</button><br/>
                      <div className="cssversion_pw100 cssversion_ph100 cssversion_colorblanco" style={{"overflowY":"auto"}}>
                        <GetItemsv2 recuperar_item={this.recuperar_itemV2} items={this.state.items} ok_item={this.state.ok_item} />
                      </div>
                    </div>
                   </div>
                  }



                   <div className="form_maitre" style={{"display": "flex"}}>
                     <div style={{"width":"100%","height":"100%","display": "inline-table"}} >
                      <div style={{"width":"100%","height":"100%","overflowY": "auto"}}>
                        <GetNota getlabelPreferenciaItem={this.getlabelPreferenciaItem}  array_nota_combo={this.state.array_nota_combo} id_item_combo={this.state.id_item_combo} id_item_preferencia={this.state.id_item_preferencia} onSecuencial={this.onSecuencial} secuencial_actual={this.state.secuencial_actual} id_cabecera={this.state.id_cabecera} consultarDetalleFacturacionAPI={this.consultarDetalleFacturacionAPI} onRemoveItem={this.onRemoveItem} array_nota={this.state.array_nota} />
                      </div>
                    </div>
                   </div>
                   </div>
                   <div>
                   </div>
                   {sub_modulo}
                  </div>
                }
              }
            } else {

              modulo =  <React.Fragment>

                          <span>Bienvenido/a {this.state.nombre_vendedor}</span>
                          <div className="grid-container-cuenta">
                            <GetCuentas getEncerarAPI={this.getEncerarAPI} nombre_maquina={this.state.nombre_maquina} Abtn_abrir_cuenta={this.Abtn_abrir_cuenta} url_proxyurl={this.state.url_proxyurl} url_global={this.state.url_global} />
                          </div>
                        </React.Fragment>
            }
          }
      }
    }

/*<div className="form_teclado">
  <div className="form_datos">
   <GetTotales nombre_vendedor={this.state.nombre_vendedor} lbl_total={this.state.lbl_total} cuenta={this.state.cuenta} />
  </div>
  <div className="form_teclado_all">
    <GetTeclado  getActualizarCabecera={this.getActualizarCabecera} cantidad={this.state.cantidad} inputChangedHandler={this.inputChangedHandler} setTeclado={this.setTeclado} cuenta={this.state.cuenta} />
  </div>
</div>*/
    let loading;
    if(this.state.loading){
      loading =<div id="loader" className="loader loader-default is-active" data-text=""></div>
    }

    //console.log("REDDNDER INICIAL");
      return(
      <div className="App">
        {loading}
        <GetTimerCajaActiva validar_caja_activa={this.validar_caja_activa} />
       {modulo}
       <div>
         <label className="css-label-config"><b>Nombre de Máquina:</b> {localStorage.nombre_maquina} </label>
         <label className="css-label-config"><b>Url Webservices:</b> {localStorage.url_global} </label>
         <label className="css-label-config"><b>Nombre de Máquina de Impresoras:</b> {localStorage.nombre_maquina_impresoras}</label>
       </div>
      </div>

    );
  }

  getVariablesAPI = () => {
    const url= this.state.url_proxyurl + this.state.url_global + "webservices/getConfiguracionV2/"+this.state.nombre_maquina;
    console.log(url);
    fetch( url)
    .then(res => res.json())
    .then((data) => {
      //this.validar_data(data[0].id_caja_diaria,data[0].id_caja);
      this.setState(
        {
          sw_tipo_pantalla:data[0].sw_tipo_pantalla,
          id_tipo_pantalla:data[0].id_tipo_pantalla
        })
    })
  }
  componentDidMount() {



        const sw_grabado  = this.state.sw_grabado;
        if(sw_grabado===''){
          if(localStorage.nombre_maquina){
            this.setState(
              {
                nombre_maquina : localStorage.nombre_maquina ,
                url_global : localStorage.url_global ,
                sw_grabado : localStorage.sw_grabado ,
                nombre_maquina_impresoras : localStorage.nombre_maquina_impresoras
              },()=>this.getVariablesAPI()
            )
            return null;
          }
        }else{

        }

    //this.consultarRubroAPI();
  }
}

export default App;
